import React from "react";
import PropTypes from "prop-types";
import Styles from "./Styles";
import { Form } from "antd";

const RegistForm = ({ items, buttons, onSubmit, form }) => {
  return (
    <Styles className='regist-form'>
      <Form form={form} onFinish={onSubmit}>
        <div className='items'>{items}</div>
        {buttons && <div className='button-area'>{buttons.map((button) => button)}</div>}
      </Form>
    </Styles>
  );
};

RegistForm.propTypes = {
  items: PropTypes.node,
  buttons: PropTypes.array,
  onSubmit: PropTypes.func,
};

RegistForm.defaultProps = {
  buttons: [],
  onSubmit: () => {},
};

export default RegistForm;
